<template>
<div>
  <b-input-group prepend="Flowline" class="mt-3">
    <b-form-select v-model="flowline" :options="metadata.identification.choices[0].children.flowline.choices"
      value-field="value" text-field="display_name" />
    <b-input-group-append>
      <b-button variant="info" @click="cargar" :disabled="!libre">Cargar inspecciones previas</b-button>
    </b-input-group-append>
  </b-input-group>
  <b-alert variant="danger" :show="msg != null">{{msg}}</b-alert>
  <b-progress :max="total" height="2rem">
    <b-progress-bar :value="avance" v-if="!msg">
      Avance: <strong>{{ avance }} / {{ total }}</strong>
    </b-progress-bar>
  </b-progress>

</div>
</template>
<script>
import PouchDB from 'pouchdb'
import metadata from '../../configuration/json/inspection.json'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      total: 0,
      avance: 0,
      pending: [],
      current: null,
      dblocal: null,
      flowline: null,
      metadata: metadata,
      libre: true,
      msg: null
    }
  },
  watch: {
    current (val) {
      var obj = this
      if (val) {
        this.dblocal.put(val).then(function () {
          obj.avance += 1
          obj.newCurrent()
        }).catch(function (err) {
          console.log(err)
          obj.msg = err.message
        })
      }
    }
  },
  mounted () {
    var obj = this
    /* var dbconfig = new PouchDB('config')
    dbconfig.get('config').then(function (config) {
      obj.dblocal = new PouchDB('inspection')
      obj.dbserver = new PouchDB(config.server + '/inspection', { skip_setup: true })
      obj.dblocal.allDocs({include_docs: true, descending: true}).then(function (data) {
        for (var i in data.rows) {
          if (!(data.rows[i].doc.synced || data.rows[i].doc._id === '_design/app')) {
            obj.libre = false
            obj.msg = 'Los registros en memoria deben ser enviados al servidor primero'
          }
        }
      }).catch(err => {
        console.log(err)
      })
    }).catch(function (err) {
      console.log(err)
    }) */
    obj.get_db({ typex: 'local', json: 'inspection' }).then(function (dblocal) {
      obj.dblocal = dblocal
      obj.dblocal.allDocs({ include_docs: true, descending: true }).then(function (data) {
        obj.msg = null
        for (var i in data.rows) {
          if (!(data.rows[i].doc.synced || data.rows[i].doc._id === '_design/app' || data.rows[i].doc._id === '_design/index')) {
            obj.libre = false
            obj.msg = 'Los registros en memoria deben ser enviados al servidor primero'
          }
        }
      }).catch(err => {
        console.log(err)
        obj.msg = err.message
      })
    }).catch(function (err) {
      console.log(err)
      obj.msg = err.message
    })
  },
  methods: {
    ...mapActions([
      'get_db'
    ]),
    newCurrent () {
      if (this.pending.length) {
        this.current = this.pending.pop()
      } else {
        this.current = null
      }
    },
    cargar () {
      let obj = this
      /* if (obj.libre) {
        this.dblocal.destroy().then(function () {
          obj.dblocal = new PouchDB('inspection')
          obj.dblocal.replicate.from(obj.dbserver, {
            doc_ids: ['_design/app']
          }).then(function () {
            obj.dbserver.query('app/latest', {
              start_key: [obj.flowline],
              end_key: [obj.flowline, {}],
              reduce: true,
              group: true
            }).then(function (result) {
              console.log(result)
              obj.total = result.rows.length
              obj.avance = 0
              for (var i in result.rows) {
                obj.pending.push(result.rows[i].value)
              }
              obj.newCurrent()
            }).catch(function (err) {
              console.log(err)
            })
          }).catch(function (err) {
            console.log(err)
          })
        }).catch(function (err) {
          console.log(err)
        })
      } */
      if (obj.libre) {
        obj.get_db({ typex: 'server', json: 'inspection' }).then(function (dbserver) {
          obj.dblocal.destroy().then(function () {
            obj.dblocal = new PouchDB('inspection')
            obj.dblocal.replicate.from(dbserver, {
              doc_ids: ['_design/app', '_design/index']
            }).then(function () {
              dbserver.query('app/latest', {
                start_key: [obj.flowline],
                end_key: [obj.flowline, {}],
                reduce: true,
                group: true
              }).then(function (result) {
                console.log(result)
                obj.total = result.rows.length
                obj.avance = 0
                for (var i in result.rows) {
                  obj.pending.push(result.rows[i].value)
                }
                obj.newCurrent()
              }).catch(function (err) {
                console.log('4', err)
                obj.msg = err.message
              })
            }).catch(function (err) {
              console.log('3', err)
              obj.msg = err.message
            })
          }).catch(function (err) {
            console.log('2', err)
            obj.msg = err.message
          })
        }).catch(function (err) {
          console.log('1', err)
          obj.msg = err.message
        })
      }
    }
  }
}
</script>
